<template>
  <b-form-group
    label="Talep No"
    label-for="title"
  >
    <b-form-input
      id="onumber"
      v-model="dataItem.onumber"
      placeholder="Talep No"
      :disabled="true"
    />

  </b-form-group>
</template>

<script>
import { localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'PurchaseOfferOnumber',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
